/**
 * railItemContainer.tsx
 */
import ScreenUtils from '@screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';
import { RailDisplayMode } from '@shared/types/enums/rail';

/**
 * Get the style for the RailItemContainer component.
 */
const getStyle = (displayMode?: RailDisplayMode) => {
  switch (displayMode) {
    case RailDisplayMode.EPG:
      return {
        marginBotton: `${8 * ScreenUtils.widthRatio}px`,
        minHeight: `${80 * ScreenUtils.widthRatio}px`,
      };
    case RailDisplayMode.SQUARE:
      return {
        marginBotton: `${18 * ScreenUtils.widthRatio}px`,
        minHeight: `${10 * ScreenUtils.widthRatio}px`,
      };
    default:
      return {
        marginBotton: `${18 * ScreenUtils.widthRatio}px`,
        minHeight: `${263 * ScreenUtils.widthRatio}px`,
      };
  }
};

const RailItemContainer = withOpacity(styled.div<{
  displayMode?: RailDisplayMode;
  hideRail?: boolean;
}>`
  ${(props) => {
    const { marginBotton, minHeight } = getStyle(props.displayMode);
    return `
      display: ${props.hideRail ? 'none' : 'flex'};
      flex-direction: column;
      margin-bottom: ${marginBotton};
      // Avoid empty space when loading a rail
      min-height: ${minHeight};
      width: max-content;
    `;
  }}
`);

export default RailItemContainer;
